import Component from 'vue-class-component';

// Register vue-router component hooks BEFORE importing any vue SFC files.
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
